import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { GetReajustePrecoListaResponse } from '../../responses/produto/get-reajuste-preco-lista.response';
import { GetReajustePrecoDetalheResponse } from '../../responses/produto/get-reajuste-preco-detalhe.response';
import { GetListasPrecoManualResponse } from '../../responses/produto/get-listas-preco-manual.response';
import { BuscarProdutosReajusteResponse } from '../../responses/produto/buscar-produtos-reajuste.response';
import { GetReajustePrecoFavoritosResponse } from '../../responses/produto/get-reajuste-preco-favoritos.response';
import { SalvarReajustePrecoFavoritoResponse } from '../../responses/produto/salvar-reajuste-preco-favorito.response';
import { ReajustePrecoBuscarProdutosRequest } from '../../requests/produto/reajuste-preco-buscar-produtos.request';
import { ReajustePrecoRequest } from '../../requests/produto/reajuste-preco.request';
import { ReajustePrecoFavoritoRequest } from '../../requests/produto/reajuste-preco-favorito.request';

@Injectable({
  providedIn: 'root',
})
export class ReajustePrecoService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiProduto}ReajustePreco`;

  public getAll(
    pesquisa: string = '',
    listIdUsuario: number[] = [],
    dataInicio: Date | null = null,
    dataFim: Date | null = null,
    pagina: number = 1,
    tamanhoPagina: number = 20
  ): Observable<GetReajustePrecoListaResponse> {
    let params = new HttpParams().set('pagina', pagina.toString()).set('tamanhoPagina', tamanhoPagina.toString());

    if (pesquisa) {
      params = params.set('pesquisa', pesquisa);
    }
    listIdUsuario.forEach(id => (params = params.append('listIdUsuario', id.toString())));
    if (dataInicio) {
      params = params.set('dataInicio', dataInicio.toISOString());
    }
    if (dataFim) {
      params = params.set('dataFim', dataFim.toISOString());
    }

    return this.httpClient
      .get<GetReajustePrecoListaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public get(idProdutoReajustePreco: number): Observable<GetReajustePrecoDetalheResponse> {
    return this.httpClient
      .get<GetReajustePrecoDetalheResponse>(`${this.apiUrl}/${idProdutoReajustePreco}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getListasPrecoManual(): Observable<GetListasPrecoManualResponse> {
    return this.httpClient
      .get<GetListasPrecoManualResponse>(`${this.apiUrl}/listasPrecoManual`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public buscarProdutos(request: ReajustePrecoBuscarProdutosRequest): Observable<BuscarProdutosReajusteResponse> {
    return this.httpClient
      .post<BuscarProdutosReajusteResponse>(`${this.apiUrl}/buscarProdutos`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvar(request: ReajustePrecoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getFavoritos(): Observable<GetReajustePrecoFavoritosResponse> {
    return this.httpClient
      .get<GetReajustePrecoFavoritosResponse>(`${this.apiUrl}/favoritos`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarFavorito(request: ReajustePrecoFavoritoRequest): Observable<SalvarReajustePrecoFavoritoResponse> {
    return this.httpClient
      .post<SalvarReajustePrecoFavoritoResponse>(`${this.apiUrl}/favoritos`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public removerFavorito(idProdutoFiltroFavorito: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/favoritos/${idProdutoFiltroFavorito}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
